export default function Loader() {
	return (
		<div className="askaiwp-typing-wrapper">
			<div className="askaiwp-typing-indicator">
				<span></span>
				<span></span>
				<span></span>
			</div>
		</div>
	);
}
